<template>
  <input-select
    :id="id"
    :name="name"
    placeholder="Please Select..."
    type="select"
    :value="value"
    :options="ethnicityOptions"
    :error="error"
    :label="label"
    @input="emitChange"
  />
</template>

<script>
import InputSelect from '@/components/inputs/InputSelect.vue';

export default {
    name: 'EthnicitySelect',
    components:{
        InputSelect
    },
    props:{
        id: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        value:{
            type: String,
            default: ''
        },
        empty_label: {
            type: String,
            default: ''
        },
        error:{
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: null
        }
    },
    computed:{
        ethnicityOptions() {
            const options = [
                { id: 'white', display_label: 'White' },
                { id: 'black', display_label: 'Black or African American' },
                { id: 'hispanic', display_label: 'Hispanic' },
                { id: 'pacific', display_label: 'Pacific' },
                { id: 'asian', display_label: 'Asian' },
                { id: 'native', display_label: 'American Indian or Alaskan Native' },
                { id: 'multiracial', display_label: 'Multiracial' },
                { id: 'preferNotToAnswer', display_label: 'Prefer not to answer' },
                { id: 'other', display_label: 'Other' },
            ];

            if (this.empty_label) options.splice(0, 0, { id: '', display_label: this.empty_label })

            return options
        }
    },
    methods:{
        emitChange(val) {
            this.$emit('input', val)
        }
    }
}
</script>

<style>

</style>
